import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ParseJson } from 'ZalamoLibrary/src/lib/core/decorators/ParseJson';
import { translationProvider } from '@ui/nls/translations/translate.directive';

@Component({
    selector: 'lib-parse-personalization',
    templateUrl: './parse-personalization.component.html',
    styleUrls: ['./parse-personalization.component.scss'],
    providers: [translationProvider('productOrderFront')],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ParsePersonalizationComponent implements OnInit {
  @Input() @ParseJson config;

  constructor() {}

  ngOnInit(): void {}
}
